import LayoutSystem from './LayoutSystem.vue'
export default LayoutSystem



// WEBPACK FOOTER //
// ./src/layouts/layoutSystem/index.js